import { over } from "lodash";
import { optional, z } from "zod";
import { dateString, numericString } from "../../../../utils";

export type PassengerStatType = "INBOUND" | "OUTBOUND";
export const PASSENGER_STAT_TYPE: Array<PassengerStatType> = ['INBOUND', 'OUTBOUND'];

export const PassengerStatsSchema = z.object({
    id: optional(z.number()),
    status: z.enum(["PENDING", "VALIDATED", "DELETED"]),
    type: z.enum(["INBOUND", "OUTBOUND"]),
    date: z.string().min(1, "Date is required"),
    number: z.string().min(1, "Flight format such as AA001"),
    registration: z.string().min(1, "Aircraft registration"),
    model: z.string().min(1, "Model is required"),
    origin: z.string().min(1, "Airport code"),
    destination: z.string().min(1, "Airport code"),
    planned_time: z.string().min(1, "Planned time is required"),
    actual_time: z.string().min(1, "Actual time is required"),
    delay_mins: numericString(undefined, true, "Number must be entered"),
    delay_codes: optional(z.string()),
    bill_mins: numericString(undefined, true, "Number must be entered"),
    created: dateString,
    created_by: z.string(),
    modified: dateString,
    modified_by: z.string(),
    validated: dateString.nullable(), 
    validated_by: z.string().nullable(),
    notes: z.string().nullable(),
    unit: z.string()
});

export const PassengerStatsSchemaUpdate = PassengerStatsSchema.extend({
    id: z.number().min(1, "ID is required")
});


// Type inference from Zod
export type PassengerStat = z.infer<typeof PassengerStatsSchema>;